import { ITab } from '@shared/ui/tabs';

export const ORGANIZERS_TAB_ID = 1;
export const CATEGORIES_TAB_ID = 2;

export const TABS_LIST: ITab[] = [
  { id: 0, title: 'Список участников' },
  { id: 3, title: 'Лидосборщик' },
  { id: 2, title: 'Категории' },
  { id: 1, title: 'Организаторы' },
];
